
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { PrivyProvider } from './providers'
import { ToastProvider } from './contexts/ToastContext'
import { ProtectedRoute } from './components/ProtectedRoute'
import { AuthSync } from './components/AuthSync'
import { ErrorFallback } from './components/ErrorFallback'
import {
  LoginScreen,
  OTPScreen,
  ReceiptCaptureScreen,
  ConfirmReceiptScreen,
  SelectTipScreen,
  SuccessScreen,
  ExportWalletScreen,
} from './screens'

const StagingBanner = () => {
  const hostname = window.location.hostname.toLowerCase()
  const isStaging = import.meta.env.DEV || hostname.startsWith('staging')

  if (!isStaging) return null

  return (
    <div
      className="text-center py-1.5 px-4 font-medium text-xs sticky top-0 z-50 text-amber-800"
      style={{
        background:
          'repeating-linear-gradient(45deg, #fef3c7, #fef3c7 8px, #fde68a 8px, #fde68a 16px)',
      }}
    >
      STAGING ENVIRONMENT
    </div>
  )
}

function App() {
  return (
    <Sentry.ErrorBoundary fallback={ErrorFallback} showDialog>
      <PrivyProvider>
        <ToastProvider>
          <BrowserRouter>
            <StagingBanner />
            <AuthSync />
            <Routes>
            {/* Public routes */}
            <Route path="/" element={<LoginScreen />} />
            <Route path="/otp" element={<OTPScreen />} />

            {/* Hidden utility routes (no in-app links) */}
            <Route path="/export-wallet" element={<ExportWalletScreen />} />

            {/* Protected routes */}
            <Route
              path="/capture"
              element={
                <ProtectedRoute>
                  <ReceiptCaptureScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path="/confirm"
              element={
                <ProtectedRoute>
                  <ConfirmReceiptScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path="/tip"
              element={
                <ProtectedRoute>
                  <SelectTipScreen />
                </ProtectedRoute>
              }
            />
            <Route
              path="/success"
              element={
                <ProtectedRoute>
                  <SuccessScreen />
                </ProtectedRoute>
              }
            />
          </Routes>
            </BrowserRouter>
        </ToastProvider>
      </PrivyProvider>
    </Sentry.ErrorBoundary>
  )
}

export default App
